import { z } from "zod";

export const isoDateTimeSchema = z.string().datetime({ offset: true });
export const idSchema = z.string().min(1);

export const actorTypeSchema = z.enum(["user", "agent", "service", "system"]);
export const sortDirectionSchema = z.enum(["asc", "desc"]);

export const paginationQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});

export const paginatedResponseSchema = <T extends z.ZodType>(itemSchema: T) =>
  z.object({
    items: z.array(itemSchema),
    nextCursor: z.string().nullable(),
  });
